import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/settings/SettingsLayout';

export const Route = createFileRoute('/app/settings')({
  component: SettingsLayout,
  staticData: { title: 'Settings' },
});
